<template>
  <div>
    <h1 class="title">
      {{ deviceName }}-火灾报警控制器操作台({{ deviceVersion | dic("SENU095") }}
      )
    </h1>
    <div class="gts200-container">
      <div class="main-box flex-between">
        <div class="left-box">
          <!-- 左侧上部 -->
          <div class="top-light flex-between">
            <div
              v-for="(item, index) in leftList"
              :key="index"
              class="light-item flex-row"
            >
              <div class="light">
                <span class="point checked" :class="[btnClass[item.type]]"></span>
                <span class="name" :class="[item.title.length === 2 ? 'letter18' : '']">{{
                  item.title
                }}</span>
              </div>
            </div>
          </div>
          <!-- 左侧中间 -->
          <div class="middle-light flex-between">
            <div class="light-box" v-for="(item, index) in middleList" :key="index">
              <div class="title">
                {{ item.title }}
              </div>
              <div
                class="light-item flex-row"
                style="width: 100%; height: 30%"
                v-for="(items, indexs) in item.list"
                :key="indexs"
              >
                <div class="light">
                  <span class="point checked" :class="[btnClass[items.type]]"></span>
                  <span class="name" style="width: 50px">{{ items.title }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 左侧底部 -->
          <div class="bottom-light flex-between">
            <div class="left">
              <div class="title-specil">火警传输</div>
              <div class="light-item flex-row" style="width: 100%; height: 54%">
                <div class="light">
                  <span class="point checked"></span>
                  <span class="name letter18" style="width: 70px">屏蔽</span>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="light-item flex-row" style="width: 100%; height: 50%">
                <div class="light">
                  <span class="point checked"></span>
                  <span class="name letter18" style="width: 70px">消音</span>
                </div>
              </div>
              <div class="light-item flex-row" style="width: 100%; height: 50%">
                <div class="light">
                  <span class="point checked"></span>
                  <span class="name letter18" style="width: 70px">故障</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 中间屏幕 -->
        <div class="middle-box">
          <div class="screen">
            {{ respondText }}
          </div>
        </div>
        <!-- 右侧 -->
        <div class="right-box">
          <div class="top-btns flex-between">
            <div
              class="fire-btn ctl-btn lh40"
              name="1"
              @click="handleCheckClick('复位', 1)"
            >
              <span>复位</span>
            </div>
            <div
              class="fire-btn ctl-btn lh40"
              name="32"
              @click="handleCheckClick('火警传输', 32)"
            >
              <span>火警传输</span>
            </div>
            <div
              class="fire-btn ctl-btn lh18"
              name="33"
              @click="handleCheckClick('消音/启动', 33)"
            >
              <span>警报器<br />消音/启动</span>
            </div>
          </div>
          <!-- 圆键盘 -->
          <div class="middle-btns">
            <!-- 控制手柄 -->
            <ul class="cloud-handel">
              <li
                class="right direction ctl-btn"
                name="5"
                @click="handleCheckClick('上', 5)"
              ></li>
              <li
                class="top direction ctl-btn"
                name="7"
                @click="handleCheckClick('左', 7)"
              ></li>
              <li
                class="right direction ctl-btn"
                name="6"
                @click="handleCheckClick('下', 6)"
              ></li>
              <li
                class="top direction ctl-btn"
                name="8"
                @click="handleCheckClick('右', 8)"
              ></li>
            </ul>
            <div class="circle-btn ctl-btn" name="2" @click="handleCheckClick('消音', 2)">
              <div class="inside-circle">消音</div>
            </div>
            <!-- 确认取消按钮 -->
            <div
              class="confirm-btn ctl-btn"
              name="3"
              @click="handleCheckClick('确认', 3)"
            >
              确认
            </div>
            <div class="cancle-btn ctl-btn" name="4" @click="handleCheckClick('取消', 4)">
              取消
            </div>
          </div>
          <div class="keybord-box flex-between">
            <div
              v-for="(items, indexs) in keyBordList"
              :key="indexs"
              :name="items.value"
              class="key-btn ctl-btn"
              @click="handleCheckClick(items.text, items.value)"
            >
              <i
                v-show="items.text === '取消检查'"
                class="icon iconfont-lunan icon-lunan-kongge"
              ></i>
              <span class="num-span">{{ items.num }}</span>
              <span class="text-span">{{ items.text }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from "./minx";
import { Dic } from "$utils";
export default {
  mixins: [mixin],
  props: {
    deviceName: {
      type: String,
      default: () => {
        return "";
      },
    },
    deviceVersion: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      leftList: [
        {
          title: "火警",
          type: "1",
        },
        {
          title: "故障",
          type: "1",
        },
        {
          title: "延时",
          type: "1",
        },
        {
          title: "系统故障",
          type: "1",
        },
        {
          title: "启动",
          type: "1",
        },
        {
          title: "主电工作",
          type: "1",
        },
        {
          title: "反馈",
          type: "1",
        },
        {
          title: "备电工作",
          type: "1",
        },
        {
          title: "屏蔽",
          type: "1",
        },
        {
          title: "监管",
          type: "1",
        },
      ],
      btnClass: {
        0: "red",
        1: "green",
        2: "gray",
      },
      middleList: [
        {
          title: "火警传输",
          list: [
            {
              title: "手动告警",
              type: "1",
            },
            {
              title: "系统故障",
              type: "1",
            },
          ],
        },
        {
          title: "气体灭火",
          list: [
            {
              title: "喷洒请求",
              type: "1",
            },
            {
              title: "气体喷洒",
              type: "1",
            },
          ],
        },
      ],
      keyBordList: [
        {
          num: "1 +",
          text: "自检",
          value: "10",
        },
        {
          num: "2 x",
          text: "锁键",
          value: "11",
        },
        {
          num: "3 =",
          text: "用户设置",
          value: "12",
        },
        {
          num: "4",
          text: "屏蔽",
          value: "13",
        },
        {
          num: "5",
          text: "取消屏蔽",
          value: "14",
        },
        {
          num: "6",
          text: "喷洒设置",
          value: "15",
        },
        {
          num: "7",
          text: "启动",
          value: "16",
        },
        {
          num: "8",
          text: "停动",
          value: "17",
        },
        {
          num: "9",
          text: "系统设置",
          value: "18",
        },
        {
          num: "*",
          text: "设备检查",
          value: "19",
        },
        {
          num: "0",
          text: "记录检查",
          value: "9",
        },
        {
          num: "",
          text: "取消检查",
          value: "31",
        },
      ],
    };
  },
  methods: {
    changeBgColor(isSuccess, btnListCode) {
      console.log(isSuccess, btnListCode);
      // btnListCode.forEach((item) => {
      //   let divItem = document.getElementsByName(item);
      //   divItem.forEach((data) => {
      //     if (isSuccess) data.classList.add("greenBg");
      //     else data.classList.add("redBg");
      //   });
      // });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.checkedIng {
  @include set_theme_color(color, main-button-bgcolor);
}
.redBg {
  background: red !important;
  color: #fff !important;
}

.greenBg {
  background: green !important;
}
.ctl-btn {
  &:hover {
    opacity: 0.6 !important;
    cursor: pointer;
  }
}
.rChecked {
  background: red !important;
}
.title {
  font-size: 18px;
  margin-bottom: 10px;
  text-align: center;
  line-height: 20px;
}
.gts200-container {
  width: 100%;
  height: 57vh;
  background: linear-gradient(180deg, #7e7e7e 0%, #777777 100%);
  opacity: 1;
  border-radius: 30px;
  padding: 10px;
  .red {
    background: linear-gradient(180deg, #ff0000 0%, #800000 100%);
  }
  .green {
    background: linear-gradient(180deg, #00ce6f 0%, #006738 100%);
  }
  .gray {
    background: linear-gradient(180deg, #eeeeee 0%, #a1a1a1 100%);
  }
  .letter18 {
    letter-spacing: 10px;
  }
  .lh40 {
    line-height: 40px;
  }
  .lh18 {
    line-height: 18px;
  }
  .light-item {
    width: 50%;
    font-size: 12px;
    .light {
      margin-right: 5px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .point {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50px;
        box-shadow: 0px 0px 0px 3px #fff;
        -webkit-box-shadow: 0px 0px 0px 3px #fff;
        -moz-box-shadow: #fff 0px 0px 3px;
      }
      .name {
        margin-left: 10px;
      }
    }
  }
  .title {
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 21px;
    color: #cfcfcf;
  }
  .main-box {
    width: 100%;
    height: 100%;
    background: #646464;
    opacity: 1;
    border-radius: 20px;
    padding: 20px 0px;
    .left-box {
      width: 26%;
      margin-right: 5px;
      color: #cfcfcf;
      .top-light {
        height: 45%;
        flex-wrap: wrap;
        padding: 0px 0px 0px 15px;
      }
      .middle-light {
        // width: 100%;
        margin: 15px 0 15px 6px;
        height: 20%;
        .light-box {
          width: 48%;
          // height: 110px;
          border: 1px solid #898989;
          opacity: 1;
          border-radius: 18px;
          padding: 10px 5px;
        }
      }
      .bottom-light {
        margin-left: 6px;
        // width: 100%;
        height: 112px;
        border: 1px solid #898989;
        opacity: 1;
        border-radius: 18px;
        padding: 15px 10px;
        > div {
          width: 45%;
        }
        .title-specil {
          font-size: 14px;
          height: 50%;
          line-height: 40px;
        }
      }
    }
    .middle-box {
      width: 40%;
      height: 100%;
      background: #000000;
      opacity: 1;
      border-radius: 15px;
      padding: 10px;
      .screen {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background: #adbfb2;
        border: 1px solid #555a56;
        opacity: 1;
        border-radius: 10px;
      }
    }
    .right-box {
      width: 32%;
      margin-left: 5px;
      .top-btns {
        margin-top: 12px;
        height: 13%;
        font-size: 12px;
        .fire-btn {
          width: 60px;
          height: 40px;
          border: 1px solid #404040;
          background: linear-gradient(180deg, #f56285 0%, #973c52 100%);
          opacity: 1;
          border-radius: 6px;
        }
      }
      .middle-btns {
        height: 50%;
        position: relative;
        .circle-btn {
          width: 56px;
          height: 56px;
          border: 1px solid #404040;
          background: linear-gradient(180deg, #00c780 0%, #006440 100%);
          border-radius: 50%;
          opacity: 1;
          position: absolute;
          left: 75px;
          top: 54px;
          .inside-circle {
            width: 50px;
            height: 50px;
            line-height: 50px;
            background: linear-gradient(360deg, #00c780 0%, #006440 100%);
            border-radius: 50%;
            margin: 1px auto;
          }
        }
        .confirm-btn {
          width: 60px;
          height: 35px;
          line-height: 35px;
          background-image: url("./img/btnleft-default.png");
          background-size: 100% 100%;
          position: absolute;
          left: 0px;
          bottom: 10px;
          cursor: pointer;
          &:hover {
            background-image: url("./img/btnleft-hover.png");
          }
        }
        .cancle-btn {
          width: 60px;
          height: 35px;
          line-height: 35px;
          background-image: url("./img/btnright-default.png");
          background-size: 100% 100%;
          position: absolute;
          right: 6px;
          bottom: 10px;
          cursor: pointer;
          &:hover {
            background-image: url("./img/btnright-hover.png");
          }
        }
        .cloud-handel {
          list-style: none;
          margin: 0;
          padding: 0;
          height: 100%;
          left: 200px;
          top: -8px;
          position: absolute;

          .top {
            top: 64px;
          }

          .right {
            right: 43px;
          }

          li {
            cursor: pointer;
            position: absolute;
            background-image: url("./img/btn-default.png");
            height: 51px;
            width: 110px;
            background-size: 100% 100%;

            &:hover {
              background-image: url("./img/btn-hover.png");
            }

            &:first-child {
              top: 10px;
            }

            &:nth-child(2) {
              right: 97px;
              transform: rotate(-90deg);
            }

            &:nth-child(3) {
              top: 118px;
              transform: rotate(-180deg);
            }

            &:last-child {
              right: -11px;
              transform: rotate(90deg);
            }
          }
        }
      }
      .keybord-box {
        height: 30%;
        flex-wrap: wrap;
        font-size: 12px;
        color: #e9e9e9;
        .key-btn {
          width: 62px;
          height: 35px;
          border: 1px solid #404040;
          background: linear-gradient(180deg, #767676 0%, #262626 100%);
          opacity: 1;
          border-radius: 18px;
          text-align: center;
          margin-bottom: 5px;
          margin-right: 5px;
          font-size: 12px;
          span {
            display: block;
          }
        }
      }
    }
  }
}
</style>
